module.exports = __webpack_public_path__ + "static/home-bubble-b099dcd99ae168fc65a90d28ce15f405.png";